const grainStyle = (intensity = 0.12) => ({
    position: 'absolute',
    inset: 0,
    zIndex: 1,
    pointerEvents: 'none',
    opacity: intensity,
    backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='256' height='256'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)' opacity='1'/%3E%3C/svg%3E")`,
    backgroundSize: '256px 256px',
    mixBlendMode: 'multiply',
    borderRadius: 'inherit',
});

export default function GrainOverlay({ intensity = 0.12 }) {
    return <div style={grainStyle(intensity)} aria-hidden="true" />;
}

export { grainStyle };
